// extracted by mini-css-extract-plugin
module.exports = {"checkCircleIcon":"thankYouMessage_checkCircleIcon__1cXL-"};